/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

class FormTags extends Component {
  state = {
    tags: '',
  };

  componentDidMount() {
    const { tagsToModify } = this.props;
    if (tagsToModify) {
      const tags = tagsToModify.join(', ');
      console.log('tags', tags);
      this.setState({ tags });
    }
  }

  changeValue = (e) => {
    const myTags = e.target.value;
    this.setState({ tags: myTags });
    const { storeText, name } = this.props;
    storeText(name, e.target.value);
  };

  render() {
    const {
      name, type, title, tag,
    } = this.props;
    const { tags } = this.state;

    return (
      <div className="w-full">
        <label className="flex flex-col font-americaMonoRegular text-xs uppercase" htmlFor={name}>
          {title}
          <input onChange={this.changeValue} name={name} type={type || 'text'} value={tags} className={` ${tag && 'pl-16'} mt-2 rounded-full border-1 p-2 bg-white outline-none  `} />
          {/* ${showError() ? 'border-red text-red' : 'border-black text-black'} */}
          {tag && (
            <span
              className="relative font-americaMonoRegular capitalize lowercase"
              style={{
                bottom: '24.5px',
                left: '11px',
                color: 'black',
                width: '30px',
              }}
            >
              {`${tag}, `}
            </span>
          )}
        </label>
      </div>
    );
  }
}

FormTags.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  storeText: PropTypes.func,
};

FormTags.defaultProps = {
  storeText: null,
  type: '',
};

export default FormTags;
